export  const options = [
    {label: 'Uzun Far', value: 'Uzun Far'},
    {label: 'Kısa Far', value: 'Kısa Far'},
    {label: 'Klima', value: 'Klima'},
    {label: 'Dönüş Sinyalleri', value: 'Dönüş Sinyalleri'},
    {label: 'Tehlike Uyarısı', value: 'Tehlike Uyarısı'},
    {label: 'Engelliler için Anlam', value: 'Engelliler için Anlam'},
    {label: 'El Freni', value: 'El Freni'},
    {label: 'Fren Arızası', value: 'Fren Arızası'},
    {label: 'Tavan Kapağı', value: 'Tavan Kapağı'},
    {label: 'Yakıt Seviyesi', value: 'Yakıt Seviyesi'},
    {label: 'Motor Soğutma Suyu Sıcaklığı', value: 'Motor Soğutma Suyu Sıcaklığı'},
    {label: 'Akıllı Şarj Durumu', value: 'Akıllı Şarj Durumu'},
    {label: 'Motor Yağı', value: 'Motor Yağı'},
    {label: 'Pozisyon Lambaları & Yan Lambalar', value: 'Pozisyon Lambaları & Yan Lambalar'},
    {label: 'Ön Sis Lambaları', value: 'Ön Sis Lambaları'},
    {label: 'Arka Sis Lambaları', value: 'Arka Sis Lambaları'},
    {label: 'Park Isıtma', value: 'Park Isıtma'},
    {label: 'Motor / MI Göstergesi', value: 'Motor / MI Göstergesi'},
    {label: 'Servis & Bakım', value: 'Servis & Bakım'},
    {label: 'Şanzıman Sıvısı', value: 'Şanzıman Sıvısı'},
    {label: 'Şanzıman Hatası', value: 'Şanzıman Hatası'},
    {label: 'ABS Arızası', value: 'ABS Arızası'},
    {label: 'Aşınmış Fren Balataları', value: 'Aşınmış Fren Balataları'},
    {label: 'Ön Cam Yıkama Sıv.', value: 'Ön Cam Yıkama Sıv.'},
    {label: 'Lastik Arızası', value: 'Lastik Arızası'},
    {label: 'Arıza/Genel Arıza', value: 'Arıza/Genel Arıza'},
    {label: 'Motor Yağı Sıcaklığı', value: 'Motor Yağı Sıcaklığı'},
    {label: 'Motor Yağı Seviyesi', value: 'Motor Yağı Seviyesi'},
    {label: 'Motor Soğutma Suyu Seviyesi', value: 'Motor Soğutma Suyu Seviyesi'},
    {label: 'Direksiyon Sıvısı Seviyesi', value: 'Direksiyon Sıvısı Seviyesi'},
    {label: 'Direksiyon Arızası', value: 'Direksiyon Arızası'},
    {label: 'Yükseklik Kontrolü', value: 'Yükseklik Kontrolü'},
    {label: 'Retarder', value: 'Retarder'},
    {label: 'Motor Emisyon Sis. Arz.', value: 'Motor Emisyon Sis. Arz.'},
    {label: 'ESC Göstergesi', value: 'ESC Göstergesi'},
    {label: 'Fren Lambası', value: 'Fren Lambası'},
    {label: '1. Körük', value: '1. Körük'},
    {label: 'Durma Talebi', value: 'Durma Talebi'},
    {label: 'Çocuk Arabası İsteği', value: 'Çocuk Arabası İsteği'},
    {label: 'Otobüs Durağı Freni', value: 'Otobüs Durağı Freni'},
    {label: 'Adblue Seviyesi', value: 'Adblue Seviyesi'},
    {label: 'Kaldırma', value: 'Kaldırma'},
    {label: 'Düşürme', value: 'Düşürme'},
    {label: 'Alçaltma', value: 'Alçaltma'},
    {label: 'Hava Filtresi', value: 'Hava Filtresi'},
    {label: 'Yakıt Filtresi Fark Basıncı', value: 'Yakıt Filtresi Fark Basıncı'},
    {label: 'Emniyet Kemeri', value: 'Emniyet Kemeri'},
    {label: 'EBS', value: 'EBS'},
    {label: 'Şeritten Ayrılma Göstergesi', value: 'Şeritten Ayrılma Göstergesi'},
    {label: 'Şeritten Ayrılma Gös. Kapalı', value: 'Şeritten Ayrılma Gös. Kapalı'},
    {label: 'Gelişmiş Acil Durum Fren Sis.', value: 'Gelişmiş Acil Durum Fren Sis.'},
    {label: 'ACC', value: 'ACC'},
    {label: 'Römork Bağlandı', value: 'Römork Bağlandı'},
    {label: 'ABS Trailer 1-2', value: 'ABS Trailer 1-2'},
    {label: 'Airbag', value: 'Airbag'},
    {label: 'EBS Trailer 1-2', value: 'EBS Trailer 1-2'},
    {label: 'Takograf Göstergesi', value: 'Takograf Göstergesi'},
    {label: 'ESC Göstergesi Kapalı', value: 'ESC Göstergesi Kapalı'},
    {label: 'Multipleks Sistemi', value: 'Multipleks Sistemi'},
    {label: 'Adblue Tahrifat', value: 'Adblue Tahrifat'},
    {label: 'Elektrik Motoru Arızaları', value: 'Elektrik Motoru Arızaları'},
    {label: 'Engine Emission Filter', value: 'Engine Emission Filter'},
    {label: 'Yardımcı Hava Basıncı', value: 'Yardımcı Hava Basıncı'},
    {label: 'Motor Bölmesi Sıcaklığı', value: 'Motor Bölmesi Sıcaklığı'},
];
